(function ($) {

    /* javascript code goes here.  Will run after page is loaded in the DOM */


    $('document').ready(function () {


        //removeIf(production)
        console.log('starting admin scripts.js');
        //endRemoveIf(production)


    })

})(jQuery);
